import * as React from 'react';
import { Button } from 'reactstrap';

interface FilterValueButtonProps {
	onClick?: () => void;
	id?: string;
	ariaExpanded?: boolean;
	ariaHasPopup?: React.AriaAttributes['aria-haspopup'];
	children: React.ReactNode;
}

/**
 * Component for filter item btn values
 *
 */
export default function FiltersListValueButton(props: FilterValueButtonProps) {
	if (props.onClick) {
		return (
			<Button
				id={props.id}
				onClick={props.onClick}
				className="filters-list-item__name-btn"
				type="button"
				aria-expanded={props.ariaExpanded}
				aria-haspopup={props.ariaHasPopup}
				data-testid="filter-list-value-button"
			>
				{props.children}
			</Button>
		);
	}

	return (
		<span id={props.id} className="filters-list-item__name-faux-btn btn" data-testid="filter-list-value-button">
			{props.children}
		</span>
	);
}
